import styled, { css } from 'styled-components'

// Todo: find correct type for "ref"
interface IRail {
  vertical: boolean
  ref: any
}

export const SliderRail = styled.div<IRail>`
  ${props => css`
    position: absolute;
    background: rgba(255, 255, 255, 0.5);
    ${props.vertical &&
      css`
        border-radius: 0 0 20px 20px;
        top: ${props.ref};
        left: 2px;
        right: 2px;
        bottom: 2px;
      `}
    ${!props.vertical &&
      css`
        height: auto;
        border-radius: 30px 0 0 30px;
        top: 3.5px;
        left: 4px;
        right: 4px;
        bottom: 3.5px;
      `}
  `}
`
